import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoInsertImportExcelTransaction(excelList, transactionTypeModel, importTransactionType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importRequest: excelList,
      transactionType: transactionTypeModel.transactionType,
      financeType: transactionTypeModel.financeType,
      expenseType: transactionTypeModel.expenseType,
      importTransactionType: importTransactionType,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/InsertImportExcelTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertImportEcommerceReceipt(excelList, ecommerceInputModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importRequest: excelList,
      ecommerceType: ecommerceInputModel.ecommerceType,
      contactId: ecommerceInputModel.contactId,
      paymentMethodId: ecommerceInputModel.paymentMethodId,
      shippingProductId: ecommerceInputModel.shippingProductId,
      isTaxInvoice: ecommerceInputModel.isTaxInvoice,
      issueDateType: ecommerceInputModel.issueDateType,
      skuTypeId: ecommerceInputModel.skuTypeId,
      skuTemplateId: ecommerceInputModel.skuTemplateId,
      settingNumberTypeId: ecommerceInputModel.settingNumberTypeId,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/InsertImportECommerceReceipt", _input, userInfo.SetHeaderService(true))
      .then((res) => {
        return res;
      });
  },
  DoGetImportTransactionTemplate(importId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importId: importId,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/GetImportTransactionTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetImportDetail(importId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importId: importId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/GetImportDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  SaveApproveTransactionTemplate(importTemplate, importTransactionType) {
    importTemplate.userId = userInfo.UserId();
    let _input = {
      merchantId: userInfo.MerchantId(),
      importTemplate: importTemplate,
      importTransactionType: importTransactionType,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/SaveApproveImportTransactionTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  SaveDraftTransactionTemplate(importTemplate, status, importTransactionType) {
    importTemplate.userId = userInfo.UserId();
    let _input = {
      merchantId: userInfo.MerchantId(),
      importStatus: status,
      importTemplate: importTemplate,
      importTransactionType: importTransactionType,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/SaveUpdateImportTransactionTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  InsertApproveTransactionTemplate(importTemplate, importTransactionType) {
    importTemplate.userId = userInfo.UserId();
    let _input = {
      merchantId: userInfo.MerchantId(),
      importTemplate: importTemplate,
      importTransactionType: importTransactionType,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/InsertApproveImportTransactionTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  InsertDraftTransactionTemplate(importTemplate, status, importTransactionType) {
    importTemplate.userId = userInfo.UserId();
    let _input = {
      merchantId: userInfo.MerchantId(),
      importStatus: status,
      importTemplate: importTemplate,
      importTransactionType: importTransactionType,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/InsertUpdateImportTransactionTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidImportTransaction(importId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importId: importId,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Import/VoidImportTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidImportTemplate(importId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importId: importId,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/VoidImportTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateIsRecommendImport() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/UpdateIsRecommendImport", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateImportTemplate(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      importId: input.importId,
      transactionCount: input.transactionCount,
      importStatus: input.importStatus,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/import/UpdateImportTemplate", _input, userInfo.SetHeaderService(true))
      .then((res) => {
        return res;
      });
  },
};
